import React from "react";
import BasePage from "../base/BasePage";
import NavBar1 from "../components/Navbar1";
import ContactPresenter from "./ContactPresenter";
import HeroContactSection from "./components/HeroContactSection";
import FooterSection from "./components/FooterSection";
import ContactDetailsSection from "./components/ContactDetailsSection";
import MapSection from "./components/MapSection";
import ContactInquiries from "./components/ContactInquiries"

import "./ContactPage.css";

class ContactPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new ContactPresenter();
  }

  // componentDidMount() {
  //   // Ensures the page starts at the top
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }

  render() {
    const heroContent = this.presenter.getHeroSectionContent();

    return (
      <>
        <NavBar1 className="shadow-sm" />

        <HeroContactSection heroContent={heroContent} />

        <ContactDetailsSection />
        
        <ContactInquiries/>

        <MapSection />
        
        <FooterSection footerText={this.presenter.getFooterContent().text} />
      </>
    );
  }
}

export default ContactPage;
